import type { ReactNode, ReactElement } from 'react';

import { alpha, styled } from '@mui/material/styles';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface CarouselControlsDownloadProps {
  onClick?: (...args: any[]) => any;
  [key: string]: any;
}

const RootStyle = styled('div')(({ theme }) => ({
  zIndex: 9,
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  bottom: theme.spacing(2),
  left: theme.spacing(2),
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.grey[900], 0.48),
}));

export default function CarouselControlsDownload({
  onClick,
}: CarouselControlsDownloadProps) {
  const { t } = useTranslation();
  return (
    <RootStyle>
      <IconButton
        aria-label={t('carousel.download-completion-image')}
        onClick={onClick}
        title={t('carousel.download-completion-image')}
      >
        <CloudDownloadIcon sx={{ color: 'white' }} />
      </IconButton>
    </RootStyle>
  );
}
